import { render, staticRenderFns } from "./LeadReport.vue?vue&type=template&id=28591d2a"
import script from "./LeadReport.vue?vue&type=script&lang=js"
export * from "./LeadReport.vue?vue&type=script&lang=js"
import style0 from "./LeadReport.vue?vue&type=style&index=0&id=28591d2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports